import {
  RUNUP_DATA_DELETE_RUNUP_REQUEST,
  RUNUP_DATA_CLEAR,
  RUNUP_DATA_CAUSE_REQUEST,
  RUNUP_DATA_MEASURE_TYPE_REQUEST,
  RUNUP_DATA_REGION_REQUEST,
  RUNUP_DATA_RUNUP_REGION_REQUEST,
  RUNUP_DATA_VALIDITY_REQUEST,
  RUNUP_DATA_TOGGLE_COLUMN,
  RUNUP_DATA_BULK_EDIT_REQUEST,
  RUNUP_DATA_CANCEL_EDIT,
  RUNUP_DATA_EDIT,
  RUNUP_DATA_SAVE_CANCEL_CONFIRMATION,
  RUNUP_DATA_SAVE_OPEN_CONFIRMATION,
} from './runupDataReducer';
import { RUNUP_DATA_SORT } from '../search/runupSearchReducer';


export const deleteRunup = ({ id, history }) => ({ type: RUNUP_DATA_DELETE_RUNUP_REQUEST, id, history });
export const getValidity = ({ history }) => ({ type: RUNUP_DATA_VALIDITY_REQUEST, history });
export const getCauses = ({ history }) => ({ type: RUNUP_DATA_CAUSE_REQUEST, history });
export const getRunupMeasurementTypes = ({ history }) => ({ type: RUNUP_DATA_MEASURE_TYPE_REQUEST, history });
export const getRegions = ({ history }) => ({ type: RUNUP_DATA_REGION_REQUEST, history });
export const getRunupRegions = ({ history }) => ({ type: RUNUP_DATA_RUNUP_REGION_REQUEST, history });
export const clearRunupData = () => ({ type: RUNUP_DATA_CLEAR });
export const sortData = sort => ({ type: RUNUP_DATA_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: RUNUP_DATA_TOGGLE_COLUMN, visibleColumns });

export const bulkEditRunups = ({ data }) => ({ type: RUNUP_DATA_BULK_EDIT_REQUEST, data });
export const openEditConfirmation = ({ formData, initialFormData }) => ({ type: RUNUP_DATA_SAVE_OPEN_CONFIRMATION, formData, initialFormData });
export const cancelEditConfirmation = () => ({ type: RUNUP_DATA_SAVE_CANCEL_CONFIRMATION });
export const startEdit = ({ initialValues }) => ({ type: RUNUP_DATA_EDIT, initialValues });
export const cancelEdit = () => ({ type: RUNUP_DATA_CANCEL_EDIT });
